import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    padding: 3em 3em 0;
    text-align: center;
    margin-bottom: 6em;

    @media all and (max-width: ${vars.mobileM}) {
        font-size: 1.1em;
        padding: 3em 1.5em 0;
    }
`;